import { Component } from '@angular/core';
import { FormControl } from '@angular/forms';
import { BaseModal } from 'shared/abstract/base-modal';

@Component({
    selector: 'app-comparison-version-selector-modal',
    templateUrl: './comparison-version-selector-modal.component.html',
    styleUrls: ['./comparison-version-selector-modal.component.scss'],
    standalone: false,
})
export class ComparisonVersionSelectorModalComponent extends BaseModal {
    public set data(value: any) {
        this.maxVersion = value.maxVersion ?? this.maxVersion;
        this.listingId = value.listingId ?? this.listingId;
        this.versions = value.versions ?? this.versions;
    }

    public versions: { version: number; label: string }[] = [];
    public formControl: FormControl<any> = new FormControl<any>(null);

    protected maxVersion: number = -1;
    protected listingId: string = '';

    constructor() {
        super();
    }

    public compareWithVersion() {
        const version = Number(this.formControl.value);
        this.closeModalInstance(version);
    }

    public closeModal() {
        this.closeModalInstance();
    }
}
